// extracted by mini-css-extract-plugin
module.exports = {"button":"Teaser_button__jEhy0","feature":"Teaser_feature__bWHSR","imageWrapper":"Teaser_imageWrapper__RcYXY","details":"Teaser_details__KJUDM","buttons":"Teaser_buttons__Kw8Y8"};